import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { BaseDrawer, BaseDrawerTitle } from '@mgm/common/components/base';
import { useAppDispatch, useAppSelector } from '../../../hooks/useAppStore';
import { getIsOpenPricingNav } from '../../../store/onboarding/selector';
import { onboardingActions } from '../../../store/onboarding/slice';
import { PRICING_PLANS } from '../data/onboarding';
import { PricingPlanCard } from './PricingPlanCard';
import { commonActions } from '../../../store/common/slice';

const AppPricingNav = () => {
  const isOpenPricingNav = useAppSelector(getIsOpenPricingNav);
  const dispatch = useAppDispatch();

  const handleCloseNav = () => {
    dispatch(onboardingActions.setIsOpenPricingNav(false));
  };

  const onCloseDrawer = () => {
    dispatch(commonActions.setToggleDrawer(false));
  };

  return (
    <BaseDrawer
      drawerProps={{
        anchor: 'right',
        width: 'auto',
        variant: 'persistent',
      }}
      onCloseDrawer={onCloseDrawer}
      open={isOpenPricingNav}
      isDisplayToolbar={false}
    >
      <BaseDrawerTitle handleClose={handleCloseNav} title="Plans that fit your scale" />
      <Divider sx={{ borderStyle: 'dashed' }} />
      <Box pt={4} px={3}>
        <Typography
          fontWeight="bold"
          textAlign="center"
          color="primary"
          fontSize={18}
        >
          Simple, transparent pricing that grows with you.
          {' '}
          <br />
          {' '}
          Try any plan free for 30 days.
        </Typography>
      </Box>
      <Box p={4}>
        <Grid container spacing={5}>
          {PRICING_PLANS.map((plan) => (
            <Grid
              key={plan.license}
              size={{
                xs: 12, md: 6,
              }}
            >
              <PricingPlanCard plan={plan} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </BaseDrawer>
  );
};

export { AppPricingNav };
